import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  Component,
  ErrorInfo,
} from 'react';
import {
  loginStore,
  getStoreData,
  getCategories,
  getProducts,
  logoutStore,
} from './services/api';
import Cookies from 'js-cookie';
 
import Lottie from 'lottie-web';
import { AnimationItem } from 'lottie-web';

import {
  MenuItem,
  CartItem,
  Order,
  AdminStats,
  LoginCredentials,
  StoreResponse,
  Category,
  Product,
} from './types';
import Flag from 'react-flagkit';
import { FixedSizeList as List } from 'react-window';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { menuItems as initialMenuItems } from './data/menu';
import { Cart } from './components/Cart';
import { OrderHistory } from './components/OrderHistory';
import { CartAndHistoryPanel } from './components/CartAndHistoryPanel';
import { orderHistoryService, createOrderFromCart, calculateCartTotal } from './services/orderHistoryService';
import { AdminDashboard } from './components/admin/AdminDashboard';

import { getMedia } from './services/storage';

import {
  Menu,
  ShoppingCart,
  AlertCircle,
  X,
  ArrowRight,
  ArrowLeft,
  History
} from 'lucide-react';
import ModernNotification from './components/ModernNotification';
import { useModernNotification } from './hooks/useModernNotification';
import { Intro } from './components/Intro';
import { OrderHoursProvider } from './context/OrderHoursContext';
import StatusBar from './components/StatusBar'; 
// SVG placeholder
const PlaceholderSVG = () => (
  <svg
    fill="#f97316"
    height="40px"
    width="40px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 60 60"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M18.35,20.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
        c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C16.555,16.088,16.555,19.01,18.35,20.805z"
      />
      <path
        d="M40.35,20.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
        c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C38.555,16.088,38.555,19.01,40.35,20.805z"
      />
      <path
        d="M29.35,14.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
        c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C27.555,10.088,27.555,13.01,29.35,14.805z"
      />
      <path
        d="M55.624,43.721C53.812,33.08,45.517,24.625,34.957,22.577c0.017-0.16,0.043-0.321,0.043-0.48c0-2.757-2.243-5-5-5
        s-5,2.243-5,5c0,0.159,0.025,0.32,0.043,0.48C14.483,24.625,6.188,33.08,4.376,43.721C2.286,44.904,0,46.645,0,48.598
        c0,5.085,15.512,8.5,30,8.5s30-3.415,30-8.5C60,46.645,57.714,44.904,55.624,43.721z M27.006,22.27
        C27.002,22.212,27,22.154,27,22.098c0-1.654,1.346-3,3-3s3,1.346,3,3c0,0.057-0.002,0.114-0.006,0.172
        c-0.047-0.005-0.094-0.007-0.140-0.012c-0.344-0.038-0.690-0.065-1.038-0.089c-0.128-0.009-0.255-0.022-0.383-0.029
        c-0.474-0.026-0.951-0.041-1.432-0.041s-0.958,0.015-1.432,0.041c-0.128,0.007-0.255,0.020-0.383,0.029
        c-0.348,0.024-0.694,0.052-1.038,0.089C27.100,22.263,27.053,22.264,27.006,22.27z M25.126,26.635
        c1.582-0.356,3.217-0.537,4.860-0.537c0.004,0,0.009,0,0.014,0c0.552,0,1,0.448,1,1.001c0,0.552-0.448,0.999-1,0.999h0
        c-0.004,0-0.009,0-0.013,0c-1.496,0-2.982,0.164-4.421,0.488c-0.074,0.017-0.148,0.024-0.221,0.024c-0.457,0-0.870-0.315-0.975-0.780
        C24.249,27.291,24.587,26.756,25.126,26.635z M19.150,28.997c0.476-0.281,1.088-0.124,1.370,0.351
        c0.282,0.476,0.125,1.089-0.351,1.370c-4.713,2.792-8.147,7.861-9.186,13.560c-0.088,0.482-0.509,0.820-0.983,0.820
        c-0.060,0-0.120-0.005-0.180-0.017c-0.543-0.099-0.904-0.619-0.805-1.163C10.158,37.658,13.947,32.080,19.150,28.997z M30,55.098
        c-17.096,0-28-4.269-28-6.5c0-0.383,0.474-1.227,2.064-2.328c-0.004,0.057-0.002,0.113-0.006,0.170C4.024,46.988,4,47.540,4,48.098
        v0.788l0.767,0.185c8.254,1.981,16.744,2.985,25.233,2.985s16.979-1.004,25.233-2.985L56,48.886v-0.788
        c0-0.558-0.024-1.109-0.058-1.658c-0.004-0.057-0.002-0.113-0.006-0.170C57.526,47.371,58,48.215,58,48.598
        C58,50.829,47.096,55.098,30,55.098z"
      />
    </g>
  </svg>
);

const mockOrders: Order[] = [
  {
    id: '1',
    items: [],
    total: 25.98,
    status: 'pending',
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];

const mockStats: AdminStats = {
  totalOrders: 150,
  totalRevenue: 2500.5,
  averageOrderValue: 16.67,
  popularItems: [],
};

import { withTranslation, WithTranslation } from 'react-i18next';

// Définir les props du composant, incluant celles fournies par withTranslation
interface AppErrorBoundaryProps extends WithTranslation {
  children: React.ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

// Error Boundary Component
class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary] Erreur interceptée:', {
      message: error.message,
      stack: error.stack,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          <h1 className="text-2xl font-bold text-red-600">
            {this.props.t('Erreur')}
          </h1>
          <p>{this.props.t("Une erreur s'est produite")}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
          >
            {this.props.t('Recharger')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Envelopper le composant avec withTranslation pour lui donner accès à t
const WrappedAppErrorBoundary = withTranslation()(AppErrorBoundary);


function App() {
  
  const { t, i18n } = useTranslation();
  const [currency, setCurrency] = useState('€');
  const lastLanguageChangeRef = useRef(Date.now());
  const googleTranslateRef = useRef<HTMLDivElement | null>(null);

  
  const notification = useModernNotification();

  const [forceRender, setForceRender] = useState(0);
  const [isVibrating, setIsVibrating] = useState(false);
  const [specError, setSpecError] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [showCart, setShowCart] = useState(false);
  const [isCartAndHistoryOpen, setIsCartAndHistoryOpen] = useState(false);

  const [menuItems, setMenuItems] = useState(initialMenuItems);
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [showSpecifications, setShowSpecifications] = useState(false);
  const [productsCache, setProductsCache] = useState<{
    [categoryId: string]: Product[];
  }>({});

  const [selectedSpecifications, setSelectedSpecifications] = useState<{
    [specId: string]: string[];
  }>({});
  const [currentSpecificationIndex, setCurrentSpecificationIndex] = useState(0);
  const [language, setLanguage] = useState<string>('fr');
const handleOrderStart = () => {
  setIsHeaderVisible(false);
  console.log('[App] En-tête masqué');
};

const handleOrderComplete = () => {
  setIsHeaderVisible(true);
  console.log('[App] En-tête réaffiché');
};








  
const cacheImages = async (imageUrls: string[]): Promise<void> => {
  try {
    const cache = await caches.open('restaurant-images');
    for (const url of imageUrls) {
      const response = await fetch(url);
      if (response.ok) {
        await cache.put(url, response.clone());
        console.log(`[Cache] Image mise en cache : ${url}`);
      } else {
        console.error(`[Cache] Échec du téléchargement de l'image : ${url}`);
      }
    }
  } catch (error) {
    console.error('[Cache] Erreur lors de la mise en cache des images :', error);
  }
};

const getCachedImage = async (url: string): Promise<string> => {
  try {
    const cache = await caches.open('restaurant-images');
    const cachedResponse = await cache.match(url);
    if (cachedResponse) {
      const blob = await cachedResponse.blob();
      return URL.createObjectURL(blob);
    }
    return url; // Retourne l'URL originale si pas en cache
  } catch (error) {
    console.error(`[Cache] Erreur lors de la récupération de l'image en cache : ${url}`, error);
    return url;
  }
};

 useEffect(() => {
    let retryCount = 0;
    const maxRetries = 3;
    const retryDelay = 5000; // 5 seconds

    const tryAutoLogin = async () => {
      if (isLoggedIn && storeData?.store?._id) {
        console.log('[App] Déjà connecté, pas besoin de relancer login');
        return;
      }
      if (retryCount >= maxRetries) {
        console.warn('[App] Nombre maximum de tentatives de connexion atteint');
        notification.showNotification({
          title: t('Erreur'),
          message: t('Échec de la connexion après plusieurs tentatives.'),
          type: 'error',
        });
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      try {
        console.log('[App] Tentative de connexion automatique', {
          attempt: retryCount + 1,
        });
        const response = await loginStore({
          email: 'sarleyline@gmail.com',
          password: '123456',
        });
        console.log(
          '[App] Réponse loginStore:',
          JSON.stringify(response, null, 2)
        );
        if (!response.success || !response.store) {
          throw new Error('Réponse loginStore invalide');
        }
        setStoreData(response);
        setIsLoggedIn(true);
        localStorage.setItem('storeData', JSON.stringify(response));
        localStorage.setItem('isLoggedIn', 'true');
        notification.showNotification({
          title: t('Connexion réussie'),
          message: t('Connexion automatique effectuée'),
          type: 'success',
        });
      } catch (error) {
        console.error('[App] Erreur connexion automatique:', {
          message: error instanceof Error ? error.message : 'Unknown error',
          stack: error instanceof Error ? error.stack : undefined,
          attempt: retryCount + 1,
        });
        setError(t('Échec de la connexion automatique'));
        notification.showNotification({
          title: t('Erreur de connexion'),
          message: t(
            'Tentative de connexion échouée. Nouvelle tentative dans quelques secondes.'
          ),
          type: 'error',
        });
        retryCount++;
        setTimeout(tryAutoLogin, retryDelay);
      } finally {
        if (retryCount >= maxRetries || (isLoggedIn && storeData?.store?._id)) {
          setIsLoading(false);
        }
      }
    };

    tryAutoLogin();  
  }, [t, notification]);




  const [profileSettings, setProfileSettings] = useState<{
    restaurantName: string;
    profileMedia: string[];
    mediaIsVideo: boolean[];
  }>({
    restaurantName: t('Milano Food'),
    profileMedia: [
      '/images/photo1.jpg',
      '/images/photo2.jpg',
      '/images/photo3.jpg',
    ],

    mediaIsVideo: [false, false, false], // Toutes sont des images
  });

  useEffect(() => {
    if (profileSettings.profileMedia.length > 1) {
      console.log(
        '[useEffect] Initialisation du carrousel média:',
        profileSettings.profileMedia
      );
      const interval = setInterval(() => {
        setCurrentMediaIndex((prev) => {
          const nextIndex = (prev + 1) % profileSettings.profileMedia.length;
          console.log('[Carrousel] Changement vers index:', nextIndex);
          return nextIndex;
        });
      }, 5000);
      return () => {
        console.log('[useEffect] Nettoyage du carrousel média');
        clearInterval(interval);
      };
    }
  }, []); // Pas de dépendance
useEffect(() => {
  const loadAndCacheImages = async () => {
    // Mettre en cache les images
    await cacheImages(profileSettings.profileMedia);

    // Récupérer les URLs en cache
    const cachedUrls = await Promise.all(
      profileSettings.profileMedia.map(async (url, index) => {
        if (!profileSettings.mediaIsVideo[index]) {
          return await getCachedImage(url);
        }
        return url; // Garder l'URL originale pour les vidéos
      })
    );

    // Mettre à jour profileSettings avec les URLs en cache
    setProfileSettings((prev) => ({
      ...prev,
      profileMedia: cachedUrls,
    }));
  };

  loadAndCacheImages();
}, []);

  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const hasLoadedSettings = useRef(false);
  const [isProductsLoading, setIsProductsLoading] = useState(false);
  const [printSettings, setPrintSettings] = useState<
    'manual' | 'auto' | 'none'
  >('manual');
  const [isTranslationEnabled, setIsTranslationEnabled] =
    useState<boolean>(true);
  const [baseLanguage, setBaseLanguage] = useState<string>('fr');
  const [googleApiKey, setGoogleApiKey] = useState<string>('');

  const [displayMode, setDisplayMode] = useState<
    'auto' | 'mobile' | 'desktop-2' | 'desktop-3'
  >('auto');

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);


  const [showIntro, setShowIntro] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [storeData, setStoreData] = useState<any>(null);
  const [loginError, setLoginError] = useState<string | undefined>(undefined);

  const lottieRefs = useRef<{ [key: string]: AnimationItem | null }>({});

  // Mock data and functions for missing variables

  const productImages: { [key: string]: string } = {};
  const subproductImages: { [key: string]: string } = {};
  const specificationSettings: any = {};
  const subproductSettings: any = {};
  const productSettings: any = {};
  const categorySettings: any = {};
  const allProducts: Product[] = [];
  const rawCurrency = '€';

  const get = async (key: string) => {
    return localStorage.getItem(key);
  };

  const cacheImage = (url: string, id?: string, type?: string) => {
    return url;
  };

  const applyClientSettings = (products: Product[]): Product[] => {
    return products;
  };

  const changeLanguage = async (lang: string) => {
    await i18n.changeLanguage(lang);
  };

// Chargement initial de storeData
useEffect(() => {
  const storedData = localStorage.getItem('storeData');
  const storedLoggedIn = localStorage.getItem('isLoggedIn');
  if (storedData && storedLoggedIn === 'true' && !isLoggedIn) {
    try {
      const parsedData = JSON.parse(storedData);
      setStoreData(parsedData);
      setIsLoggedIn(true);
    } catch (error) {
      console.error('Erreur lors du chargement de storeData:', error);
      localStorage.removeItem('storeData');
      localStorage.removeItem('isLoggedIn');
    }
  }
}, []); // Aucune dépendance, exécuté une seule fois

// Appel à fetchCategories
useEffect(() => {
  if (isLoggedIn && storeData?.store?._id && categories.length === 0) {
    fetchCategories();
  }
}, [isLoggedIn, storeData, categories]);
  useEffect(() => {
    if (
      storeData?.store?._id &&
      storeData?.store?.server_token &&
      selectedCategory &&
      !isLoading &&
      !productsCache[selectedCategory]
    ) {
      console.log(
        '[useEffect] Déclenchement fetchProducts pour:',
        selectedCategory
      );
      fetchProducts(selectedCategory);
    }
  }, [
    selectedCategory,
    storeData?.store?._id,
    storeData?.store?.server_token,
    isLoading,
    t,
    notification,
  ]);

  useEffect(() => {
    if (categories.length > 0 && !selectedCategory) {
      console.log(
        '[useEffect] Définition de la catégorie initiale:',
        categories[0]._id
      );
      setSelectedCategory(categories[0]._id);
    }
  }, [categories]);

  const fetchCategories = async () => {
    if (!storeData?.store?._id || !storeData?.store?.server_token) {
      console.warn('[fetchCategories] storeData manquant:', {
        storeData,
        isLoggedIn,
        localStorage: {
          storeData: localStorage.getItem('storeData'),
          isLoggedIn: localStorage.getItem('isLoggedIn'),
        },
      });
      notification.showNotification({
        title: t('Erreur'),
        message: t('Connexion au magasin requise'),
        type: 'error',
      });
      return;
    }
    if (categories.length > 0) {
      console.log('[fetchCategories] Catégories déjà chargées, arrêt.');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      console.log('[fetchCategories] Appel API avec:', {
        storeId: storeData.store._id,
        serverToken: storeData.store.server_token,
      });
      const response = await getCategories(
        storeData.store._id,
        storeData.store.server_token
      );
      console.log(
        '[fetchCategories] Réponse complète:',
        JSON.stringify(response, null, 2)
      );
      if (!response.success) {
        console.warn('[fetchCategories] Réponse API non réussie:', response);
        notification.showNotification({
          title: t('Erreur'),
          message: t('Échec du chargement des catégories: {message}', {
            message: response.message || 'Erreur inconnue',
          }),
          type: 'error',
        });
        setCategories([]);
        return;
      }
      if (!response.product_groups || response.product_groups.length === 0) {
        console.warn('[fetchCategories] Aucune catégorie reçue:', response);
        notification.showNotification({
          title: t('Aucune catégorie'),
          message: t('Aucune catégorie disponible pour ce magasin.'),
          type: 'warning',
        });
      }
      setCategories(response.product_groups || []);
      if (response.product_groups?.length > 0 && !selectedCategory) {
        setSelectedCategory(response.product_groups[0]._id);
      }
    } catch (error) {
      console.error('[fetchCategories] Erreur:', {
        message: error instanceof Error ? error.message : 'Unknown error',
        stack: error instanceof Error ? error.stack : undefined,
      });
      setError(t('Erreur lors du chargement des catégories'));
      notification.showNotification({
        title: t('Erreur'),
        message: t('Échec du chargement des catégories'),
        type: 'error',
      });
      setCategories([]);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchProducts = async (categoryId: string): Promise<Product[]> => {
    if (
      !storeData?.store?._id ||
      !storeData?.store?.server_token ||
      !categoryId
    ) {
      console.warn('[fetchProducts] Données manquantes:', {
        storeData,
        categoryId,
        isLoggedIn,
      });
      notification.showNotification({
        title: t('Erreur'),
        message: t('Connexion au magasin requise pour charger les produits'),
        type: 'error',
      });
      return [];
    }
    if (productsCache[categoryId]) {
      console.log('[fetchProducts] Utilisation du cache pour:', categoryId);
      setProducts(productsCache[categoryId]);
      return productsCache[categoryId];
    }
    try {
      const selectedCat = categories.find((cat) => cat._id === categoryId);
      if (!selectedCat) {
        console.warn('[fetchProducts] Catégorie non trouvée:', categoryId);
        notification.showNotification({
          title: t('Erreur'),
          message: t('Catégorie non trouvée'),
          type: 'error',
        });
        return [];
      }
      if (!selectedCat.product_ids?.length) {
        console.warn(
          '[fetchProducts] Aucun product_id dans la catégorie:',
          selectedCat
        );
        notification.showNotification({
          title: t('Aucun produit'),
          message: t('Aucun produit trouvé pour cette catégorie'),
          type: 'warning',
        });
        return [];
      }
      console.log(
        '[fetchProducts] Appel API pour product_ids:',
        selectedCat.product_ids
      );
      const productPromises = selectedCat.product_ids.map((id) =>
        getProducts(storeData.store._id, storeData.store.server_token, id)
      );
      const responses = await Promise.all(productPromises);
      const products = responses.reduce((acc, res) => {
        if (res.success && res.products?.[0]?.items) {
          console.log(
            '[fetchProducts] Produits reçus pour ID:',
            res.products[0]._id,
            res.products[0].items
          );
          return [
            ...acc,
            ...res.products[0].items.map((p: Product) => ({
              ...p,
              categoryId,
            })),
          ];
        }
        console.warn('[fetchProducts] Réponse invalide pour un produit:', res);
        return acc;
      }, [] as Product[]);
      console.log('[fetchProducts] Produits finaux:', products);
      if (products.length === 0) {
        console.warn(
          '[fetchProducts] Aucun produit valide pour la catégorie:',
          categoryId
        );
        notification.showNotification({
          title: t('Aucun produit'),
          message: t('Aucun produit disponible pour cette catégorie'),
          type: 'warning',
        });
      }
      setProductsCache((prev) => {
        if (JSON.stringify(prev[categoryId]) === JSON.stringify(products)) {
          return prev; // Évite la mise à jour si identique
        }
        return { ...prev, [categoryId]: products };
      });
      setProducts(products);
      return products;
    } catch (error) {
      console.error('[fetchProducts] Erreur:', {
        message: error instanceof Error ? error.message : 'Unknown error',
        stack: error instanceof Error ? error.stack : undefined,
      });
      notification.showNotification({
        title: t('Erreur'),
        message: t('Échec du chargement des produits'),
        type: 'error',
      });
      return [];
    }
  };


 


  
  const handleCategoryChange = useCallback(
    async (categoryId: string, force: boolean = false) => {
      if (!force && categoryId === selectedCategory) {
        console.log(
          '[handleCategoryChange] Même catégorie, arrêt:',
          categoryId
        );
        return;
      }
      if (productsCache[categoryId] && !force) {
        console.log(
          '[handleCategoryChange] Utilisation du cache pour:',
          categoryId
        );
        setSelectedCategory(categoryId);
        setProducts(productsCache[categoryId]);
        return;
      }
      setIsLoading(true);
      try {
        setSelectedCategory(categoryId);
        const products = await fetchProducts(categoryId);
        if (products.length > 0) {
          setIsLoading(false); // Comme dans ta solution précédente
        }
      } catch (error) {
        console.error('[handleCategoryChange] Erreur:', error);
        notification.showNotification({
          title: t('errors.fetchProducts'),
          message: t('errors.fetchProductsFailed'),
          type: 'error',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [selectedCategory, storeData, productsCache, t, notification]
  );
  const handleLogin = async (credentials: LoginCredentials) => {
    console.log('[App] Tentative de login:', { credentials });
    try {
      const response = await loginStore(credentials);
      console.log('[App] Réponse loginStore:', {
        storeId: response?.store?._id,
        serverToken: response?.store?.server_token,
        fullResponse: response,
      });
      if (!response?.store?._id || !response?.store?.server_token) {
        console.error('[App] Réponse loginStore invalide:', response);
        throw new Error('Données du magasin manquantes dans la réponse');
      }
      setStoreData(response);
      setIsLoggedIn(true);
      setLoginError(undefined);
      console.log('[App] storeData défini:', response);
      notification.showNotification({
        title: t('Connexion réussie'),
        message: t('Vous êtes connecté'),
        type: 'success',
      });
    } catch (error: any) {
      console.error('[App] Erreur lors de la connexion:', {
        message: error.message,
        stack: error.stack,
        response: error.response,
      });
      setLoginError(t('Échec de la connexion'));
      notification.showNotification({
        title: t('Erreur de connexion'),
        message: t('Échec de la connexion'),
        type: 'error',
      });
    }
  };

  const handleLogout = async () => {
    try {
      if (storeData?.store) {
        await logoutStore(storeData.store._id, storeData.store.server_token);
      }
      setStoreData(null);
      setIsLoggedIn(false);
      setCategories([]);
      setProducts([]);
      localStorage.clear();
      Cookies.remove('storeId');
      Cookies.remove('serverToken');
      notification.showNotification({
        title: t('Déconnexion réussie'),
        message: t('Vous avez été déconnecté'),
        type: 'info',
      });
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
      notification.showNotification({
        title: t('Erreur de déconnexion'),
        message: t('Problème déconnexion'),
        type: 'error',
      });
    }
  };
  const handleSpecificationChange = (specId: string, optionId: string) => {
    setSelectedSpecifications((prev) => {
      const current = prev[specId] || [];
      const spec = selectedProduct?.specifications.find(
        (s) => s._id === specId
      );
      if (!spec) {
        console.warn('[handleSpecificationChange] Spécification non trouvée', {
          specId,
        });
        return prev;
      }

      console.log('[handleSpecificationChange] Changement de sélection', {
        specId,
        optionId,
        type: spec.type,
        range: spec.range,
        max_range: spec.max_range,
        is_required: spec.is_required,
        currentSelections: current,
      });

      if (spec.type === 2) {
        const maxRange =
          spec.max_range > 0
            ? spec.max_range
            : spec.range > 0
            ? spec.range
            : 10;
        if (current.includes(optionId)) {
          return { ...prev, [specId]: current.filter((id) => id !== optionId) };
        }
        if (current.length >= maxRange) {
          console.warn(
            '[handleSpecificationChange] Limite de sélection atteinte',
            {
              specId,
              maxRange,
              currentCount: current.length,
            }
          );
          notification.showNotification({
            title: t('Limite atteinte'),
            message: t(
              "Vous ne pouvez sélectionner que jusqu'à {count} options pour {name}",
              {
                count: maxRange,
                name: spec.name[0] || t('cette option'),
              }
            ),
            type: 'warning',
          });
          return prev;
        }
        return { ...prev, [specId]: [...current, optionId] };
      } else {
        return { ...prev, [specId]: [optionId] };
      }
    });
  };

  const handleNextSpecification = () => {
    if (!selectedProduct) {
      console.error('[handleNextSpecification] Aucun produit sélectionné');
      setSpecError('unknown');
      notification.showNotification({
        title: t('Erreur'),
        message: t('Produit non trouvé. Veuillez réessayer.'),
        type: 'error',
      });
      return;
    }

    const visibleSpecs = selectedProduct.specifications.filter(
      (spec) =>
        specificationSettings[selectedProduct._id]?.[spec._id]?.visible ?? true
    );

    if (visibleSpecs.length === 0) {
      console.warn('[handleNextSpecification] Aucune spécification visible');
      addToCart(selectedProduct, selectedSpecifications);
      setShowSpecifications(false);
      setCurrentSpecificationIndex(0);
      notification.showNotification({
        title: t('Produit ajouté'),
        message: t('Produit ajouté au panier', {
          name: selectedProduct.name[0],
        }),
        type: 'success',
      });
      return;
    }

    const currentSpec = visibleSpecs[currentSpecificationIndex];
    if (!currentSpec) {
      console.error('[handleNextSpecification] Spécification introuvable', {
        index: currentSpecificationIndex,
        totalSpecs: visibleSpecs.length,
      });
      setSpecError('unknown');
      notification.showNotification({
        title: t('Erreur'),
        message: t('Spécification non trouvée. Veuillez réessayer.'),
        type: 'error',
      });
      return;
    }

    const selections = selectedSpecifications[currentSpec._id] || [];

    if (currentSpec.is_required && currentSpec.list.length > 0) {
      if (selections.length === 0) {
        setSpecError(currentSpec._id);
        setIsVibrating(true);
        setTimeout(() => setIsVibrating(false), 900);
        const name = currentSpec.name[0] || t('cette option');
        console.warn(
          '[handleNextSpecification] Aucune sélection pour une spécification requise',
          {
            specId: currentSpec._id,
            name,
          }
        );
        notification.showNotification({
          title: t('Sélection requise'),
          message: t('Veuillez sélectionner une option pour {name}', { name }),
          type: 'warning',
        });
        return;
      }

      if (currentSpec.type === 2 && currentSpec.range > 0) {
        if (selections.length < currentSpec.range) {
          setSpecError(currentSpec._id);
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 900);
          const name = currentSpec.name[0] || t('cette option');
          console.warn('[handleNextSpecification] Sélections insuffisantes', {
            specId: currentSpec._id,
            required: currentSpec.range,
            selected: selections.length,
            name,
          });
          notification.showNotification({
            title: t('Sélection incomplète'),
            message: t('Veuillez sélectionner options', {
              count: currentSpec.range,
              name,
            }),
            type: 'warning',
          });
          return;
        }
      }
    }

    setSpecError(null);
    setIsVibrating(false);

    if (currentSpecificationIndex < visibleSpecs.length - 1) {
      setCurrentSpecificationIndex(currentSpecificationIndex + 1);
    } else {
      console.log(
        '[handleNextSpecification] Toutes les spécifications complétées',
        {
          selectedSpecifications,
        }
      );
      addToCart(selectedProduct, selectedSpecifications);
      setShowSpecifications(false);
      setCurrentSpecificationIndex(0);
      setSelectedSpecifications({});
      notification.showNotification({
        title: t('Produit ajouté'),
        message: t('Produit ajouté au panier', {
          name: selectedProduct.name[0],
        }),
        type: 'success',
      });
    }
  };

  const handlePreviousSpecification = () => {
    if (currentSpecificationIndex > 0)
      setCurrentSpecificationIndex(currentSpecificationIndex - 1);
  };

  const handleAddToCart = useCallback(
    async (product: Product) => {
      try {
        if (product.specifications && product.specifications.length > 0) {
          setSelectedProduct(product);
          setShowSpecifications(true);
          setSelectedSpecifications({});
          setCurrentSpecificationIndex(0);
          return;
        }
        addToCart(product, {});
        notification.showNotification({
          title: t('Produit ajouté'),
          message: t('Produit ajouté au panier', { name: product.name[0] }),
          type: 'success',
        });
      } catch (error) {
        console.error('[handleAddToCart] Erreur:', error);
        notification.showNotification({
          title: t('Erreur'),
          message: t("Impossible d'ajouter le produit au panier"),
          type: 'error',
        });
      }
    },
    [t]
  );

  const addToCart = (
    product: Product,
    specifications: { [key: string]: string[] }
  ) => {
    setCartItems((prev) => {
      const additionalPrice = Object.entries(specifications).reduce(
        (total, [specId, optionIds]) => {
          const spec = product.specifications.find((s) => s._id === specId);
          if (!spec) return total;
          return (
            total +
            optionIds.reduce((sum, optId) => {
              const option = spec.list.find((opt) => opt._id === optId);
              return sum + (option?.price || 0);
            }, 0)
          );
        },
        0
      );

const menuItem: MenuItem = {
  id: product._id,
  name: product.name[0],
  description: product.details[0],
  price: product.price, // Supprime additionalPrice
  image: product.image_url[0]
    ? `https://api.restomi.fr/${product.image_url[0]}`
    : '',
  category: selectedCategory,
  available: product.is_item_in_stock,
  customizations: [],
  tax: product.tax || 0,
  tax_details: product.tax_details || [],
};

      const selectedCustomizations: {
        [key: string]: { id: string; name: string; price: number }[];
      } = {};
      Object.entries(specifications).forEach(([specId, optionIds]) => {
        const spec = product.specifications.find((s) => s._id === specId);
        if (spec) {
          const selectedOptions = spec.list
            .filter((opt) => optionIds.includes(opt._id))
            .map((opt) => ({
              id: opt._id,
              name: opt.name[0],
              price: opt.price,
            }));
          if (selectedOptions.length > 0) {
            selectedCustomizations[spec.name[0]] = selectedOptions;
          }
        }
      });

      const uniqueId = `${product._id}-${Date.now()}`;
      if (!isMobile) setShowCart(true);
      return [
        ...prev,
        {
          menuItem,
          quantity: 1,
          customizations: selectedCustomizations,
          uniqueId,
        },
      ];
    });

    setShowSpecifications(false);
    setSelectedProduct(null);
    setCurrentSpecificationIndex(0);
  };
 
  const handleUpdateQuantity = (uniqueId: string, quantity: number) => {
    if (quantity < 1) {
      handleRemoveItem(uniqueId);
      return;
    }
    setCartItems((prev) =>
      prev.map((item) =>
        item.uniqueId === uniqueId ? { ...item, quantity } : item
      )
    );
  };

  const handleRemoveItem = (uniqueId: string) => {
    setCartItems((prev) => {
      const itemToRemove = prev.find((item) => item.uniqueId === uniqueId);
      if (itemToRemove) {
        notification.showNotification({
          title: t('Produit retiré'),
          message: t('Produit retiré du panier', {
            name: itemToRemove.menuItem.name,
          }),
          type: 'info',
        });
      }
      return prev.filter((item) => item.uniqueId !== uniqueId);
    });
  };

 const handleCheckout = async () => {
    notification.showNotification({
      title: t('Commande confirmée'),
      message: t('Votre commande confirmée'),
      type: 'success',
    });
    setCartItems([]);
    setShowCart(false);

    if (categories.length > 0) {
      const firstCategoryId = categories[0]._id;
      console.log(
        '[handleCheckout] Resélection de la première catégorie:',
        firstCategoryId
      );
      setSelectedCategory(firstCategoryId);
      await handleCategoryChange(firstCategoryId, true);
      console.log(
        '[handleCheckout] handleCategoryChange terminé pour:',
        firstCategoryId
      );
    } else {
      console.warn('[handleCheckout] Aucune catégorie disponible');
      notification.showNotification({
        title: t('Erreur'),
        message: t('Aucune catégorie disponible pour sélection'),
        type: 'warning',
      });
      await fetchCategories();
    }

    await changeLanguage(baseLanguage);
    console.log('[handleCheckout] Changement de langue terminé');
  };

  const handleUpdateMenuItem = (updatedItem: MenuItem) => {
    setMenuItems((prev) =>
      prev.map((item) => (item.id === updatedItem.id ? updatedItem : item))
    );
  };

  const handleUpdateOrderStatus = (
    orderId: string,
    status: Order['status']
  ) => {
    console.log('Mise à jour du statut de la commande:', orderId, status);
  };

  const toggleAdmin = () => {
    setIsAdmin(!isAdmin);
    if (!isAdmin && !isLoggedIn) setStoreData(null);
  };

  const handlePrintSettingsChange = (
    newSettings: 'manual' | 'auto' | 'none'
  ) => {
    setPrintSettings(newSettings);
    notification.showNotification({
      title: t('Paramètres impression mis à jour'),
      message: t('Mode impression défini', {
        mode:
          newSettings === 'manual'
            ? t('manuel')
            : newSettings === 'auto'
            ? t('automatique')
            : t('aucun'),
      }),
      type: 'success',
    });
    console.log('printSettings mis à jour dans App :', newSettings);
  };

  useEffect(() => {
    const updateDisplay = () => {
      if (displayMode === 'mobile') {
        setIsMobile(true);
      } else if (displayMode === 'desktop-2' || displayMode === 'desktop-3') {
        setIsMobile(false);
      } else {
        setIsMobile(window.innerWidth < 600);
      }
    };

    updateDisplay();
    window.addEventListener('resize', updateDisplay);
    return () => window.removeEventListener('resize', updateDisplay);
  }, [displayMode]);

  useEffect(() => {
    if (i18n.language !== language) {
      console.log('[useEffect] Synchronisation language:', {
        i18nLanguage: i18n.language,
        stateLanguage: language,
      });
      setLanguage(i18n.language);
      setForceRender((prev) => prev + 1);
    }
  }, [i18n.language, language]);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.warn('Erreur capturée:', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
      });
    };
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  return (
    <WrappedAppErrorBoundary>
      <OrderHoursProvider>
      {showIntro ? (
        <Intro onFinish={() => setShowIntro(false)} />
      ) : (
        <div className="relative">
          <StatusBar />
          {isAdmin ? (
            isLoggedIn ? (
              <>
                <button
                  onClick={toggleAdmin}
                  className="fixed top-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-lg z-0"
                >
                  {t('Mode client')}
                </button>

               

 
                <ModernNotification
                  title={notification.title}
                  message={notification.message}
                  type={notification.type}
                  isOpen={notification.isOpen}
                  onClose={notification.hideNotification}
                  duration={notification.duration}
                  actions={notification.actions}
                />
              </>
            ) : (
              <div>Login Form Placeholder</div>
            )
          ) : (
            <div className="h-screen overflow-hidden">
              {(() => {
                const headerHeight = isMobile
                  ? Math.round(window.innerHeight * 0.2)
                  : Math.round(window.innerHeight * 0.3);
                const mainHeight = isMobile
                  ? Math.round(window.innerHeight * 0.8)
                  : Math.round(window.innerHeight * 0.7);
                const sidebarWidth = Math.max(
                  Math.round(window.innerWidth * 0.2),
                  150
                );
                const cartWidth = Math.max(
                  Math.round(window.innerWidth * 0.25),
                  200
                );
                const contentWidth = Math.max(
                  Math.round(window.innerWidth * 0.55),
                  300
                );

                return (
                  <>


                   {isHeaderVisible && ( 
                    <header
                      className="fixed top-0 left-0 right-0 z-0"
                      style={{ height: `${headerHeight}px` }}
                    >
                      <div className="relative w-full h-full">
                        <button
                          className="absolute top-4 left-4 z-30 group"
                          onClick={() => {
                            let clickCount =
                              ((window as any).fullscreenClickCount || 0) + 1;
                            (window as any).fullscreenClickCount = clickCount;
                            clearTimeout(
                              (window as any).fullscreenClickTimeout
                            );
                            (window as any).fullscreenClickTimeout = setTimeout(
                              () => ((window as any).fullscreenClickCount = 0),
                              1000
                            );
                            if (clickCount === 4) {
                              if (!isFullscreen)
                                document.documentElement
                                  .requestFullscreen()
                                  .catch((err) => console.error(err));
                              else
                                document
                                  .exitFullscreen()
                                  .catch((err) => console.error(err));
                              (window as any).fullscreenClickCount = 0;
                              setIsFullscreen(!isFullscreen);
                            }
                          }}
                          aria-label={t('Basculer plein écran')}
                        >
                          <div className="w-2 h-2 bg-white/10 rounded-full transition-all duration-300 group-hover:bg-white/30 group-hover:w-3 group-hover:h-3" />
                        </button>
                        <button
                          className="absolute top-4 left-10 z-30 group"
                          onClick={() => {
                            let settingsClickCount =
                              ((window as any).settingsClickCount || 0) + 1;
                            (window as any).settingsClickCount =
                              settingsClickCount;
                            clearTimeout((window as any).settingsClickTimeout);
                            (window as any).settingsClickTimeout = setTimeout(
                              () => ((window as any).settingsClickCount = 0),
                              1000
                            );
                            if (settingsClickCount === 10) {
                              toggleAdmin();
                              (window as any).settingsClickCount = 0;
                            }
                          }}
                          aria-label={t('Basculer mode admin')}
                        >
                          <div className="w-2 h-2 bg-white/10 rounded-full transition-all duration-300 group-hover:bg-white/30 group-hover:w-3 group-hover:h-3" />
                        </button>
                        {isLoading ? (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded-t-2xl">
                            <div className="animate-pulse text-gray-500">
                              {t('Chargement')}
                            </div>
                          </div>
                        ) : profileSettings.profileMedia &&
                          profileSettings.profileMedia.length > 0 ? (
                      <div className="w-full h-full rounded-b-2xl shadow-lg overflow-hidden z-0">
                            {profileSettings.mediaIsVideo[currentMediaIndex] ? (
                              <video
                                key={
                                  profileSettings.profileMedia[
                                    currentMediaIndex
                                  ]
                                }
                                ref={videoRef}
                                src={
                                  profileSettings.profileMedia[
                                    currentMediaIndex
                                  ]
                                }
                                className="w-full h-full object-cover"
                                autoPlay
                                muted
                                playsInline
                                loop={profileSettings.profileMedia.length === 1}
                                onError={() => {
                                  console.error(
                                    'Profile video error:',
                                    profileSettings.profileMedia[
                                      currentMediaIndex
                                    ]
                                  );
                                  notification.showNotification({
                                    title: t('Erreur'),
                                    message: t(
                                      'Impossible de charger la vidéo.'
                                    ),
                                    type: 'error',
                                  });
                                  // Ne change pas l'index pour éviter la boucle
                                }}
                              />
                            ) : (
                              <img
                                key={
                                  profileSettings.profileMedia[
                                    currentMediaIndex
                                  ]
                                }
                                src={
                                  profileSettings.profileMedia[
                                    currentMediaIndex
                                  ]
                                }
                                alt={t('Logo du restaurant')}
                                className="w-full h-full object-contain"
                                onError={() => {
                                  console.error(
                                    'Profile image error:',
                                    profileSettings.profileMedia[
                                      currentMediaIndex
                                    ]
                                  );
                                  notification.showNotification({
                                    title: t('Erreur'),
                                    message: t(
                                      "Impossible de charger l'image."
                                    ),
                                    type: 'error',
                                  });
                                  // Ne change pas l'index pour éviter la boucle
                                }}
                              />
                            )}
                            <div className="absolute inset-x-0 bottom-0 h-1/6 bg-gradient-to-t from-orange-100 to-transparent" />
                          <div className="absolute inset-0 bg-black/20 z-[-1]" /> 
                          </div>
                        ) : (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded-t-2xl">
                            <PlaceholderSVG />
                          </div>
                        )}

                        <div className="absolute inset-x-0 top-0 p-4">
                          <div className="container mx-auto px-4 flex justify-between items-start">
                            <h1
                              className={`
                      text-2xl md:text-4xl font-bold tracking-tight
                      text-white
                      px-4 py-2
                      animate-fade-in animate-neon
                      font-playfair
                      inline-block
                      text-wrap
                      max-h-24
                      drop-shadow-[0_0_12px_rgba(255,165,0,0.8)]
                      ${
                        profileSettings.restaurantName.length > 25
                          ? 'text-xl md:text-3xl'
                          : ''
                      }
                    `}
                            >
                              {profileSettings.restaurantName}
                            </h1>
                          <div className="flex items-center gap-3 shrink-0 min-w-fit">
  <button
    onClick={() => setIsCartAndHistoryOpen(true)}
    className="relative p-2.5 bg-white/10 backdrop-blur-md rounded-full hover:bg-white/20 transition-colors"
    aria-label={t('Voir l\'historique des commandes')}
  >
    <History size={22} className="text-white" />
  </button>
  <button
    onClick={() => setShowCart(!showCart)}
    className="relative p-2.5 bg-white/10 backdrop-blur-md rounded-full hover:bg-white/20 transition-colors"
    aria-label={
      showCart
        ? t('Fermer le panier')
        : t('Ouvrir le panier')
    }
  >
    {cartItems.length > 0 && (
      <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium">
        {cartItems.length}
      </span>
    )}
    {showCart ? (
      <Menu size={22} className="text-white" />
    ) : (
      <ShoppingCart size={22} className="text-white" />
    )}
  </button>
</div>
                          </div>
                        </div>
                      </div> 
                    </header>


                    )}

                    <main
                      className={`fixed inset-x-0 bottom-0 flex ${
                        isMobile ? 'flex-col' : 'flex-row'
                      } transition-all duration-300 ease-in-out`}
                      style={{
                        height: `${mainHeight}px`,
                        top: `${headerHeight}px`,
                      }}
                    >
                      {isMobile && (
                        <div className="md:hidden w-full overflow-x-auto hide-scrollbar bg-white z-10 p-2">
                          <div className="flex space-x-2 px-2">
                            {categories.length > 0 ? (
                              categories.map((category) => (
                                <button
                                  key={category._id}
                                  onClick={() =>
                                    handleCategoryChange(category._id)
                                  }
                                  className={`flex-shrink-0 group transition-all duration-300 ${
                                    selectedCategory === category._id
                                      ? 'ring-2 ring-orange-500 ring-offset-2'
                                      : 'hover:ring-1 hover:ring-orange-300 hover:ring-offset-1'
                                  }`}
                                  aria-label={t('Sélectionner catégorie', {
                                    name: category.name[0],
                                  })}
                                >
                                  <div className="w-[90px] flex flex-col items-center">
                                    <h3 className="text-gray-900 text-sm font-medium tracking-wide mb-1 text-center">
                                      {category.name[0]}
                                    </h3>
                                    <div className="relative aspect-[3/2] rounded-xl overflow-hidden">
                                      {category.image_url ? (
                                        <img
                                          src={`https://api.restomi.fr/${category.image_url}`}
                                          alt={category.name[0]}
                                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                                          loading="lazy"
                                          onError={(e) => {
                                            e.currentTarget.style.display =
                                              'none';
                                            if (e.currentTarget.nextSibling)
                                              (
                                                e.currentTarget
                                                  .nextSibling as HTMLElement
                                              ).style.display = 'flex';
                                          }}
                                        />
                                      ) : (
                                        <div
                                          className="w-full h-full flex items-center justify-center bg-gray-100 rounded-xl"
                                          style={{ display: 'flex' }}
                                        >
                                          <PlaceholderSVG />
                                        </div>
                                      )}
                                    </div>
                                    {selectedCategory === category._id && (
                                      <div className="absolute -bottom-0.5 left-1/2 transform -translate-x-1/2 w-3 h-0.5 bg-orange-500 rounded-full" />
                                    )}
                                  </div>
                                </button>
                              ))
                            ) : (
                              <div className="text-center text-gray-500 p-2">
                                {t('Aucune catégorie disponible')}
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {!isMobile && (
                        <aside
                          className="overflow-y-auto hide-scrollbar bg-white"
                          style={{ width: `${sidebarWidth}px` }}
                        >
                          <div className="p-4 space-y-4">
                            {(() => {
                              if (isLoading) {
                                return Array.from({ length: 4 }).map(
                                  (_, index) => (
                                    <div key={index} className="animate-pulse">
                                      <div className="aspect-[4/3] bg-gray-200 rounded-xl mb-2"></div>
                                      <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                                    </div>
                                  )
                                );
                              }
                              if (error) {
                                return (
                                  <div className="text-center py-8">
                                    <div className="text-red-500 mb-2">
                                      {error}
                                    </div>
                                    <button
                                      onClick={fetchCategories}
                                      className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
                                    >
                                      {t('Réessayer')}
                                    </button>
                                  </div>
                                );
                              }
                              if (categories.length === 0) {
                                return (
                                  <div className="text-center py-8 text-gray-500">
                                    {t('Aucune catégorie disponible')}
                                  </div>
                                );
                              }
                              return categories.map((category) => (
                                <button
                                  key={category._id}
                                  onClick={() =>
                                    handleCategoryChange(category._id)
                                  }
                                  className={`group w-full transition-all duration-300 ${
                                    selectedCategory === category._id
                                      ? 'ring-2 ring-orange-500 ring-offset-2'
                                      : 'hover:ring-1 hover:ring-orange-300 hover:ring-offset-1'
                                  }`}
                                  aria-label={t('Sélectionner catégorie', {
                                    name: category.name[0],
                                  })}
                                >
                                  <div className="relative">
                                    <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
                                      {category.image_url ? (
                                        <img
                                          src={`https://api.restomi.fr/${category.image_url}`}
                                          alt={category.name[0]}
                                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                                          loading="lazy"
                                          onError={(e) => {
                                            e.currentTarget.style.display =
                                              'none';
                                            if (e.currentTarget.nextSibling)
                                              (
                                                e.currentTarget
                                                  .nextSibling as HTMLElement
                                              ).style.display = 'flex';
                                          }}
                                        />
                                      ) : (
                                        <div
                                          className="w-full h-full flex items-center justify-center bg-gray-50 rounded-xl"
                                          style={{ display: 'flex' }}
                                        >
                                          <PlaceholderSVG />
                                        </div>
                                      )}
                                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent opacity-100 transition-opacity" />
                                    </div>
                                    <div className="absolute inset-x-0 bottom-0 p-3 text-center">
                                      <h3 className="text-white font-medium tracking-wide text-shadow-lg transform transition-transform duration-300 group-hover:scale-105">
                                        {category.name[0]}
                                      </h3>
                                    </div>
                                    {selectedCategory === category._id && (
                                      <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-orange-500 rounded-full" />
                                    )}
                                  </div>
                                </button>
                              ));
                            })()}
                          </div>
                        </aside>
                      )}

                      <div
                        className="flex-1 overflow-y-auto hide-scrollbar bg-gray-50"
                        style={{
                          width: !isMobile ? `${contentWidth}px` : '100%',
                        }}
                      >
                        <div className="p-4">
                          {products.length === 0 && !isLoading && !error ? (
                            <div className="text-center py-8 text-gray-500">
                              {t('Aucun produit disponible')}
                              <button
                                onClick={() =>
                                  handleCategoryChange(selectedCategory)
                                }
                                className="mt-4 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
                              >
                                {t('Réessayer')}
                              </button>
                            </div>
                          ) : (
                            <div
                              className={`grid gap-4 justify-items-stretch ${
                                displayMode === 'mobile' || isMobile
                                  ? 'grid-cols-1'
                                  : displayMode === 'desktop-2'
                                  ? 'grid-cols-2'
                                  : 'grid-cols-3'
                              }`}
                            >
                              {products
                                .filter((product) => product.is_item_in_stock)
                                .map((product) => (
                                  <div
                                    key={product._id}
                                    className="product-card group relative bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-500 ease-out hover:shadow-xl hover:scale-[1.03] w-full h-full min-h-[400px] flex flex-col justify-between cursor-pointer"
                                    onClick={() => handleAddToCart(product)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        handleAddToCart(product);
                                      }
                                    }}
                                    aria-label={t('Ajouter au panier', {
                                      name: product.name[0],
                                    })}
                                  >
                                    <div className="relative h-60 overflow-hidden">
                                      {productImages[product._id] ? (
                                        <>
                                          <img
                                            src={productImages[product._id]}
                                            alt={product.name[0]}
                                            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                                            loading="lazy"
                                            style={{
                                              objectFit: 'contain',
                                              objectPosition: 'center',
                                              transform: 'scale(0.95)',
                                            }}
                                            onError={(e) => {
                                              const target = e.currentTarget;
                                              target.style.display = 'none';
                                              if (target.nextSibling)
                                                (
                                                  target.nextSibling as HTMLElement
                                                ).style.display = 'flex';
                                            }}
                                          />
                                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />
                                        </>
                                      ) : product.image_url[0] ? (
                                        <>
                                          <img
                                            src={cacheImage(
                                              `https://api.restomi.fr/${product.image_url[0]}`,
                                              product._id,
                                              'product'
                                            )}
                                            alt={product.name[0]}
                                            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                                            loading="lazy"
                                            style={{
                                              objectFit: 'contain',
                                              objectPosition: 'center',
                                              transform: 'scale(0.95)',
                                            }}
                                            onError={(e) => {
                                              const target = e.currentTarget;
                                              target.style.display = 'none';
                                              if (target.nextSibling)
                                                (
                                                  target.nextSibling as HTMLElement
                                                ).style.display = 'flex';
                                            }}
                                          />
                                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />
                                        </>
                                      ) : (
                                        <div
                                          className="w-full h-full flex items-center justify-center bg-gray-100 rounded-t-2xl transition-transform duration-700 ease-out group-hover:scale-110"
                                          style={{ display: 'flex' }}
                                        >
                                          <div
                                            style={{ transform: 'scale(3)' }}
                                          >
                                            <PlaceholderSVG />
                                          </div>
                                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />
                                        </div>
                                      )}
                                      <div className="absolute top-3 right-3 bg-green-500 text-white text-xs font-semibold px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                                        {t('Disponible')}
                                      </div>
                                    </div>
                                    <div className="p-5 flex flex-col justify-between flex-grow">
                                      <div>
                                        <h3 className="text-lg font-semibold text-gray-900 mb-2 whitespace-normal break-words transition-colors duration-300 group-hover:text-orange-600">
                                          {product.name[0]}
                                        </h3>
                                        <p className="text-gray-500 text-sm mb-4 line-clamp-3 min-h-[4rem]">
                                          {product.details[0]}
                                        </p>
                                      </div>
                                      <div className="flex flex-col items-center gap-3">
                                        <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent transition-transform duration-300 group-hover:scale-105">
                                          {product.price.toFixed(2)} {currency}
                                        </span>
                                        <button
                                          className="relative w-full py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg font-medium text-sm overflow-hidden transition-all duration-500 group"
                                          disabled={!product.is_item_in_stock}
                                          aria-hidden="true"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleAddToCart(product);
                                          }}
                                        >
                                          <span className="absolute inset-0 bg-gradient-to-r from-orange-600 to-red-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                          <span className="relative flex items-center justify-center gap-2">
                                            <ShoppingCart
                                              size={18}
                                              className="transition-transform duration-300 group-hover:scale-110"
                                            />
                                            {t('Ajouter au panier')}
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                    <div className="absolute inset-0 border-2 border-transparent group-hover:border-orange-500/30 rounded-2xl transition-all duration-500 ease-out pointer-events-none" />
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>

                      {!isMobile && (
                        <aside
                          className="block overflow-y-auto hide-scrollbar bg-gray-50 transition-all duration-300 ease-in-out"
                          style={{ width: `${cartWidth}px` }}
                        >
                          <div className="pr-4 pl-2 py-4">
                            <Cart
                              items={cartItems}
                              onUpdateQuantity={handleUpdateQuantity}
                              onRemoveItem={handleRemoveItem}
                              onCheckout={handleCheckout}
                              printSettings={printSettings}
                              currency={currency}
                            />
                          </div>
                        </aside>
                      )}
                    </main>

                    {isMobile && (
                      <>
                        <button
                          onClick={() => setShowCart(!showCart)}
                          className="fixed bottom-4 right-4 bg-orange-500 text-white p-3 rounded-full shadow-lg hover:bg-orange-600 transition-colors z-50"
                          style={{ width: '60px', height: '60px' }}
                          aria-label={
                            showCart
                              ? t('Fermer le panier')
                              : t('Ouvrir le panier')
                          }
                        >
                          {cartItems.length > 0 && (
                            <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium">
                              {cartItems.length}
                            </span>
                          )}
                          <ShoppingCart size={24} />
                        </button>

                        {showCart && (
                          <div
                            className="fixed inset-0 bg-white p-4 z-50 overflow-y-auto transition-opacity duration-300 ease-in-out"
                            style={{ top: `${headerHeight}px` }}
                          >
                            <div className="flex items-center justify-end space-x-2">
                              <button
                                onClick={() => setShowCart(false)}
                                className="p-2 text-gray-600 hover:text-gray-800 rounded-full hover:bg-gray-100 transition-colors z-60 flex items-center space-x-2"
                                aria-label={t('Fermer le panier')}
                              >
                                <ShoppingCart size={20} />
                                {cartItems.length > 0 && (
                                  <span className="bg-red-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-medium">
                                    {cartItems.length}
                                  </span>
                                )}
                                <X size={20} />
                              </button>
                            </div>
                            <Cart
                              items={cartItems}
                              onUpdateQuantity={handleUpdateQuantity}
                              onRemoveItem={handleRemoveItem}
                              onCheckout={handleCheckout}
                              printSettings={printSettings}
                              currency={currency}
                            />
                          </div>
                        )}
                      </>
                    )}

{showSpecifications && selectedProduct && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-1000">
    <div className="bg-white rounded-2xl w-full max-w-2xl shadow-2xl p-6 flex flex-col max-h-[80vh]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-gray-800">
          {t('Personnalisez votre', {
            name: selectedProduct.name[0] || t('Produit', 'Produit'),
          })}
        </h3>
        <button
          onClick={() => {
            setShowSpecifications(false);
            setSelectedProduct(null);
            setCurrentSpecificationIndex(0);
            Object.values(lottieRefs.current).forEach((anim) => anim?.destroy());
            lottieRefs.current = {};
          }}
          className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors"
        >
          <X size={20} />
        </button>
      </div>

      {(() => {
        const modifiedProduct = applyClientSettings([selectedProduct])[0] || selectedProduct;
        const visibleSpecs = modifiedProduct.specifications.filter(
          (spec) => specificationSettings[modifiedProduct._id]?.[spec._id]?.visible ?? true
        );

        if (visibleSpecs.length === 0) {
          return (
            <div className="text-center text-gray-500 py-4">
              {t('Aucune option disponible', 'Aucune option disponible')}
            </div>
          );
        }

        const spec = visibleSpecs[currentSpecificationIndex] || visibleSpecs[0];
        const selections = selectedSpecifications[spec._id] || [];
        const maxSelections =
          spec.type === 2
            ? spec.max_range > 0
              ? spec.max_range
              : spec.range > 0
              ? spec.range
              : 10
            : 1;
        const minSelections = spec.is_required ? spec.range : 0;
        const currentSelections = selections.length;

        const getMessage = (key: string, params: any, fallback: string) => {
          const message = t(key, params);
          if (message.includes('{count}') || message === key) {
            console.warn(
              `[Popup] Traduction échouée pour "${key}", utilisation du fallback: ${fallback}`
            );
            return fallback;
          }
          return message;
        };

        return (
          <div className="flex flex-col h-full">
            <div className="flex-1 space-y-6 overflow-y-auto hide-scrollbar pr-2 pb-4">
              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-500">
                    {t(
                      'Étape',
                      {
                        current: currentSpecificationIndex + 1,
                        total: visibleSpecs.length,
                      },
                      `Étape ${currentSpecificationIndex + 1} sur ${visibleSpecs.length}`
                    )}
                  </span>
                  <span className="text-sm font-medium text-orange-500">
                    {Math.round(((currentSpecificationIndex + 1) / visibleSpecs.length) * 100)}%
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-orange-500 h-2 rounded-full transition-all duration-300"
                    style={{
                      width: `${((currentSpecificationIndex + 1) / visibleSpecs.length) * 100}%`,
                    }}
                  ></div>
                </div>
              </div>

              <div key={spec._id} className="space-y-3">
                <div className="flex items-center justify-between">
                  <div>
                    <label className="font-medium text-gray-700">
                      {spec.name[0] || t('Option', 'Option')}
                      {spec.is_required && <span className="text-red-500 ml-1">*</span>}
                    </label>
                    <div
                      className={`flex items-center gap-2 text-gray-600 font-medium text-sm mt-1 ${
                        specError === spec._id && isVibrating ? 'animate-vibrate text-red-600' : ''
                      }`}
                    >
                      <svg
                        className={`w-4 h-4 ${specError === spec._id ? 'text-red-600' : 'text-gray-400'}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01M12 17h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <span>
                        {spec.is_required && minSelections > 0
                          ? getMessage(
                              'Sélectionnez exactement',
                              { count: minSelections },
                              `Sélectionnez ${minSelections} option${minSelections !== 1 ? 's' : ''}`
                            )
                          : getMessage(
                              "Sélectionnez jusqu'à",
                              { count: maxSelections },
                              `Sélectionnez jusqu'à ${maxSelections} option${maxSelections !== 1 ? 's' : ''}`
                            )}
                      </span>
                    </div>
                    {spec.is_required && !selections.length && (
                      <div className="flex items-center gap-2 p-2 rounded-lg text-amber-600 bg-amber-50 font-medium text-sm mt-1">
                        <svg
                          className="w-4 h-4 text-amber-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01M12 17h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span>{t('Option requise', 'Option obligatoire')}</span>
                      </div>
                    )}
                  </div>
                  {spec.type === 2 && maxSelections > 0 && (
                    <span
                      className={`text-sm font-medium px-2 py-1 rounded-full ${
                        currentSelections >= maxSelections
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}
                    >
                      {getMessage(
                        'Sélections compteur',
                        { current: currentSelections, max: maxSelections },
                        `${currentSelections}/${maxSelections} sélectionnée${currentSelections !== 1 ? 's' : ''}`
                      )}
                    </span>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-2">
                  {spec.list
                    .filter(
                      (option) =>
                        subproductSettings[modifiedProduct._id]?.[option.name?.[0]]?.visible ?? true
                    )
                    .map((option) => {
                      const isSelected = selections.includes(option._id);
                      const canSelect =
                        spec.type === 2
                          ? maxSelections === 0 || currentSelections < maxSelections || isSelected
                          : true;
                      const imageKey = `${modifiedProduct._id}:${option.name?.[0]}`;

                      return (
                        <button
                          key={option._id}
                          onClick={() => canSelect && handleSpecificationChange(spec._id, option._id)}
                          disabled={!canSelect && !isSelected}
                          className={`p-3 rounded-xl border-2 transition-all flex items-center gap-2 ${
                            isSelected
                              ? 'border-orange-500 bg-orange-50 shadow-orange-100'
                              : canSelect
                              ? 'border-gray-200 hover:border-orange-200'
                              : 'border-gray-100 bg-gray-50 opacity-50 cursor-not-allowed'
                          }`}
                        >
                          {option.animation ? (
                            <div
                              className="w-20 h-20"
                              ref={(el) => {
                                if (el && !lottieRefs.current[imageKey]) {
                                  lottieRefs.current[imageKey] = Lottie.loadAnimation({
                                    container: el,
                                    animationData: JSON.parse(option.animation),
                                    renderer: 'svg',
                                    loop: true,
                                    autoplay: true,
                                  });
                                }
                              }}
                            />
                          ) : subproductImages[imageKey] ? (
                            <img
                              src={subproductImages[imageKey]}
                              alt={option.name?.[0]}
                              className="w-20 h-20 object-cover rounded-md"
                              onError={(e) => {
                                e.currentTarget.style.display = 'none';
                                console.error('Erreur chargement image:', option.name?.[0]);
                              }}
                            />
                          ) : null}
                          <div>
                            <div className="font-medium text-gray-800">
                              {option.name?.[0] || t('Option', 'Option')}
                            </div>
                            {(subproductSettings[modifiedProduct._id]?.[option.name?.[0]]?.price ??
                              option.price) > 0 && (
                              <div className="text-sm text-orange-600 mt-1">
                                +
                                {(
                                  subproductSettings[modifiedProduct._id]?.[option.name?.[0]]?.price ??
                                  option.price
                                ).toFixed(2)}{' '}
                                {currency}
                              </div>
                            )}
                          </div>
                        </button>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="sticky bottom-0 bg-white pt-4 border-t border-gray-200">
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowSpecifications(false);
                    setSelectedProduct(null);
                    setCurrentSpecificationIndex(0);
                    Object.values(lottieRefs.current).forEach((anim) => anim?.destroy());
                    lottieRefs.current = {};
                  }}
                  className="px-4 py-3 text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors"
                >
                  {t('Annuler', 'Annuler')}
                </button>
                <div className="flex-1 flex gap-2">
                  {currentSpecificationIndex > 0 && (
                    <button
                      onClick={handlePreviousSpecification}
                      className="flex-1 px-4 py-3 text-orange-500 bg-orange-50 rounded-xl hover:bg-orange-100 transition-colors flex items-center justify-center gap-2"
                    >
                      <ArrowLeft size={18} />
                      <span>{t('Précédent', 'Précédent')}</span>
                    </button>
                  )}
                  <button
                    onClick={handleNextSpecification}
                    className="flex-1 px-4 py-3 text-white bg-orange-500 rounded-xl hover:bg-orange-600 transition-colors flex items-center justify-center gap-2"
                  >
                    {currentSpecificationIndex < visibleSpecs.length - 1 ? (
                      <>
                        <span>{t('Suivant', 'Suivant')}</span>
                        <ArrowRight size={18} />
                      </>
                    ) : (
                      <span>{t('Ajouter au panier', 'Ajouter au panier')}</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  </div>
)}
<CartAndHistoryPanel
  isOpen={isCartAndHistoryOpen}
  onClose={() => setIsCartAndHistoryOpen(false)}
  cartItems={cartItems}
  onUpdateQuantity={handleUpdateQuantity}
  onRemoveItem={handleRemoveItem}
  onCheckout={handleCheckout}
  printSettings={printSettings}
  currency={currency}
/>
                    <ModernNotification
                      title={notification.title}
                      message={notification.message}
                      type={notification.type}
                      isOpen={notification.isOpen}
                      onClose={notification.hideNotification}
                      duration={notification.duration}
                      actions={notification.actions}
                    />
                  </>
                );
              })()}
            </div>
          )}
        </div>
      )}
        </OrderHoursProvider>
    </WrappedAppErrorBoundary>
  );
}

export default App; 
 